export default __webpack_public_path__ + "static/media/app-store-icon.f9dea889.png";